// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import { AutocompleteClassKey } from "@material-ui/lab";
import { CSSProperties } from "@material-ui/styles";
import { Overrides as CoreOverrides } from "@material-ui/core/styles/overrides";
import getSassStyle from "./sassStyle";

// extension solution from https://github.com/mui-org/material-ui/issues/12164
interface Overrides extends CoreOverrides {
  // Define additional lab components here as needed....
  MuiAutocomplete?:
    | Partial<
        Record<AutocompleteClassKey, CSSProperties | (() => CSSProperties)>
      >
    | undefined;
}

export default {
  MuiFormHelperText: {
    root: {
      padding: 0,
      margin: 0,
      "&.Mui-error": {
        color: getSassStyle().errorcolor,
      },
    },
    contained: {
      marginLeft: 0,
      marginRight: 0,
    },
  },
  MuiFormLabel: {
    root: {
      color: getSassStyle().bodycolor,
      fontWeight: getSassStyle().strongweight,
    },
  },
  MuiInputLabel: {
    formControl: {
      position: "relative",
      zIndex: 1,
      "& + .MuiInput-formControl": {
        marginTop: 0,
      },
    },
  },
  MuiPaper: {
    root: {
      color: getSassStyle().bodycolor,
    },
  },
  MuiAutocomplete: {
    inputRoot: {
      paddingTop: "0px !important",
      paddingBottom: "0px !important",
    },
    input: {
      padding: "6px 0 7px !important",
    },
  },
  MuiDialogTitle: {
    root: {
      color: getSassStyle().bodycolor,
      padding: "8px 14px",
      "& + .MuiDialogContent-root": {
        paddingTop: "0px",
      },
    },
  },
  MuiDialogContent: {
    root: {
      color: getSassStyle().bodycolor,
      padding: "14px 14px 8px",
      "&:first-child": {
        paddingTop: "8px",
      },
    },
  },
  MuiDialogActions: {
    root: {
      padding: "8px 14px",
    },
  },
  MuiLink: {
    button: {
      fontWeight: 500,
      "&:hover": {
        textDecoration: "none",
      },
    },
  },
  MuiDrawer: {
    paper: {
      backgroundColor: getSassStyle().bodybackgroundcolor,
      textAlign: "center",
      maxWidth: "100%",
      width: "350px",
    },
  },
} as Overrides;
